import './index.css'
import video from './assets/schütze-bau.mp4'
import background from "./assets/hintergrund.jpg"
import { Navbar, Landingpage } from './components'


function App() {

  return (
      <>
        <Landingpage />
        <Navbar/>
      </>
  );
}

export default App;
